import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Activities from "../pages/activities/page";
import News from "../pages/news/page";
import Contact from "../pages/contact/page";
import Sponsorship from "../pages/sponsorship/page";
import Membership from "../pages/membership/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/activities", element: <Activities /> },
  { path: "/news", element: <News /> },
  { path: "/contact", element: <Contact /> },
  { path: "/sponsorship", element: <Sponsorship /> },
  { path: "/membership", element: <Membership /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
